import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import en from './locales/en';

export const translations = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en,
};

export const languageNames = {
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
    'en': 'English',
};
